import { TableCell, TableRow } from '@material-ui/core';
import * as React from 'react';
import * as ReactQuill from 'react-quill';
import { Constants } from '../abstract';
// tslint:disable-next-line:ordered-imports
import { StringModel } from '../../../models';
import { Views } from '../../abstract';

const StringTableViewHeader = [
    { label: 'Русский' },
    { label: 'Английский' }
]

interface IStringTableViewProps {
    onSearchString: (s: string) => void
    onTextChange: (v: string, cName: string, index: number) => void
    snackbarText: string
}

interface IStringTableViewState {
    selectedRows: object[]
    page: number
}

class StringTableView<P, S> extends Views.TableView<P & IStringTableViewProps, S & IStringTableViewState> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            selectedRows: [],
            model: this.props.model,
            isDeleteConfirmationDialogOpened: false,
            page: 0
        }
        this.state = defaultState
    }

    public componentWillReceiveProps(nextProps: any, nextContext: any) {
        this.setState({ snackbarText: nextProps.snackbarText })
    }

    public rowAtIndex(str: StringModel, index: number): JSX.Element {
        const cellStyle = { width: '50%' } as React.CSSProperties;
        return (
            <TableRow key={index.toString()}>
                <TableCell style={cellStyle}>{this.renderField(str.ru, 'ru', str, index)}</TableCell>
                <TableCell style={cellStyle}>{this.renderField(str.ru, 'en', str, index)}</TableCell>
            </TableRow>
        )
    }

    public renderField(chechStr: string, lang: string, str: StringModel, index: number) {
        const { onTextChange } = this.props;
        if (/<[a-z][\s\S]*>/i.test(chechStr)) {
            return (
                <ReactQuill
                    modules={{
                        syntax: true,
                        clipboard: {
                            matchVisual: false,
                        },
                        toolbar: Constants.QuillEditorConstants.toolbarOptions
                    }}
                    placeholder={lang === 'ru' ? 'Русский' : 'Английский'}
                    onChange={(v: any) => onTextChange(v, lang, index)}
                    className="editor-view"
                    style={{ margin: '20px 0' }}
                    // readOnly={lang === 'ru' ? true : false}
                    value={str[lang] || ''}
                />)
        } else {
            return (<Views.TextField
                floatingLabelText={lang === 'ru' ? 'Русский' : 'Английский'}
                fullWidth={true}
                multiLine={true}
                style={{ margin: '20px 0' }}
                data-field-type="nml"
                disabled={lang === 'ru' ? true : false}
                name="en"
                value={str[lang] || ''}
                onChange={(e) => onTextChange(e.target['value'], lang, index)}
            />)
        }
    }

    public withCheck() { return false; }

    public render_topBar(): JSX.Element {
        const { selectedRows } = this.state;
        const { onSearchString } = this.props;
        return (
            <>
                {this.snackbar()}
                <Views.StandartTableViewTopBar
                    onSearch={(sText: string) => onSearchString(sText)}
                    editDisabled={selectedRows.filter(r => r['selected'] === true).length !== 1 ? true : false}
                    deleteDisabled={selectedRows.filter(r => r['selected'] === true).length === 0 ? true : false}
                />
            </>
        )
    }

    public tableViewHeader() {
        return StringTableViewHeader;
    }

    public labelRowsPerPage() {
        return 'Текстов на странице:';
    }
}

export default StringTableView;



// WEBPACK FOOTER //
// ./src/app/dashboard/translates/TranslatesView.tsx